import { toast } from 'react-toastify';
import {useState, useEffect} from 'react';
import {useUploadSiteFileMutation, useDeleteSiteFileMutation} from '../../slices/sitesApiSlice';
import { Form, Row, Col, Table, Button} from 'react-bootstrap'
import {Trash3 } from 'react-bootstrap-icons';

const SiteDocs = (filesite) => {

    const [uploadSiteFile, {isLoading, error}] = useUploadSiteFileMutation();
    const [deleteSiteFile] = useDeleteSiteFileMutation();
    
    const [files, setFiles] = useState(filesite.filesite.files);
    const [site, setSite] = useState(filesite.filesite);
  
    useEffect(() => {
        if(filesite.filesite){
            setFiles(filesite.filesite.files);
        }
    }, [filesite.filesite])
   
    const deleteDoc = async (index) => {
        if (window.confirm('Are you sure you want to delete this file?')) {
            const currFile = files[index];
            removeDoc(currFile);
        }
    }

    const removeDoc = async (file) => {
        try {
            const res = await deleteSiteFile({"file": file, "site": site}).unwrap();
            setFiles(res.updatedFiles || res.updatedImages || files.filter(f => f.path !== file.path)); // Fallback in case backend returns something else
            toast.success(res.message || "File deleted");
        } catch (error) {
            toast.error(error?.data?.message || error.error || "Failed to delete file");
        }
    }
 
    const uploadFileHandler = async (e) => {
        const formData = new FormData();
        for (let i = 0; i < e.target.files.length; i++) {
            formData.append('files', e.target.files[i]);
          }
        formData.append('siteID', filesite.filesite._id);
        formData.append('fileType', "files");
        try{
            const res = await uploadSiteFile(formData).unwrap();
            toast.success(res.message);
            const uploadFiles = [];
            for(let i = 0; i< res.files.length; i++){
                let newFile = {
                    name: res.files[i].name,
                    path: res.files[i].path
                }
                uploadFiles.push(newFile);
            }
            setFiles([...files, ...uploadFiles])
        }catch (error){
            toast.error(error?.data?.message || error.error);
        }
    }


    return   isLoading ? (
        <h2>Loading</h2>
    ): error ? (
        <div>{error?.data?.message || error.error}</div>
    ) : (
        <>
        <Row>
            <Col>
                <Form>
                    <Form.Group controlId='file' className='my-2'>
                        <Form.Control type='file' multiple label='Choose File(s)' onChange={uploadFileHandler}></Form.Control>
                    </Form.Group>
                </Form>
            </Col>
        </Row>


        <Row>
            <Col>
            
              
                    { files ? files.map((file, index) => (
                        <Row key={index}>
                            <Col md={9}>
                                <p>
                                    <a 
                                        href={file.path.startsWith('/') && process.env.NODE_ENV === 'development' ? `http://localhost:5000${file.path}` : file.path} 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                    >
                                        {file.name}
                                    </a>
                                </p>
                            </Col>
                            <Col>
                                <button className='tableButton' onClick={() => deleteDoc(index)}><Trash3 /></button>
                            </Col>
                        </Row>
                     )) : <p>No Files</p>}
          
            </Col>
        </Row>
    
        </>
      );
}

export default SiteDocs;